export const CornerAccents = ({ color = '#6366F1' }) => (
  <>
    {[
      'top-3 left-3 border-t-2 border-l-2 rounded-tl',
      'top-3 right-3 border-t-2 border-r-2 rounded-tr',
      'bottom-3 left-3 border-b-2 border-l-2 rounded-bl',
      'bottom-3 right-3 border-b-2 border-r-2 rounded-br',
    ].map((pos) => (
      <span
        key={pos}
        aria-hidden
        className={`pointer-events-none absolute w-3.5 h-3.5 z-20 ${pos}`}
        style={{ borderColor: color, opacity: 0.65, filter: `drop-shadow(0 0 3px ${color})` }}
      />
    ))}
  </>
);
